import React from 'react';
import {NavBar} from './components/';
import {BrowserRouter as Router} from 'react-router-dom';
import SwitchControl from './pages';

const App = () => {
  return (
      <Router>
        <NavBar/>
          <div className="container">
            <SwitchControl/>
          </div> 
      </Router>
  );
}

export default App;
